<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="aprazamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Aprazar: 

                            <template v-if="item.anamnese && item.anamnese.atendimento_procedimento && item.anamnese.atendimento_procedimento.atendimento">
                                {{ item.anamnese.atendimento_procedimento.atendimento.paciente.search }}

                                <span class="badge badge-secondary ml-2" 
                                    v-if="item.anamnese.atendimento_procedimento.atendimento.marcacao && item.anamnese.atendimento_procedimento.atendimento.marcacao.in_qt_dia">
                                    D{{ item.anamnese.atendimento_procedimento.atendimento.marcacao.in_qt_dia }}
                                </span>

                                <span class="ml-2" v-if="item.dt_inclusao">
                                    | {{ $util.getFormatDate(item.dt_inclusao) }} {{ item.dt_inclusao.slice(11, 16) }}
                                </span> 
                            </template>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-danger" v-if="item.anamnese && item.anamnese.atendimento_procedimento && item.anamnese.atendimento_procedimento.atendimento && item.anamnese.atendimento_procedimento.atendimento.paciente && item.anamnese.atendimento_procedimento.atendimento.paciente.alergias && item.anamnese.atendimento_procedimento.atendimento.paciente.alergias.length">
                            <div class="lead">Alergias:</div>
                            <div v-for="(alergia, iax) in item.anamnese.atendimento_procedimento.atendimento.paciente.alergias" :key="iax">
                                <strong>{{ alergia.tipo.search }}</strong>
                                <template v-if="alergia.st_observacoes">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>{{ alergia.st_observacoes }}
                                </template>
                            </div>
                        </div>

                        <div class="alert alert-danger" v-if="item.fl_suspensa">
                            <i class="fa-solid fa-triangle-exclamation fa-fw mr-3"></i>
                            <strong>Suspensa</strong>
                        </div>

                        <table class="table table-hover">
                            <div v-if="item.dt_valid_ini && item.dt_valid_fim" class="alert alert-secondary d-flex justify-content-between px-2 py-1">
                                <div>
                                    Validade: {{ $util.getFormatDate(item.dt_valid_ini) }} {{ item.dt_valid_ini.slice(11,16) }} 
                                    até {{ $util.getFormatDate(item.dt_valid_fim) }} {{ item.dt_valid_fim.slice(11,16) }}
                                </div>
                                <div>
                                    <template v-if="item.solicitacao">
                                        Solic: #{{ item.solicitacao.id_estoque_solicitacao }}
                                        <i class="fa-solid fa-lock ml-2"></i>
                                    </template>
                                </div>
                            </div>
                            <div v-else-if="item.in_duracao > 1 && item.anamnese && item.anamnese.atendimento_procedimento.atendimento.id_tipo_atendimento == 7" class="alert alert-secondary d-flex justify-content-between px-2 py-1">
                                <div>
                                    Prescrito em {{ $util.getFormatDate(item.dt_referencia) }}
                                </div>
                                <div>
                                    Duração: {{ item.in_duracao }} dias.
                                </div>
                            </div>

                            <tr v-for="(medic, imx) in item.items" :key="imx">
                                <div class="row">
                                    <div class="col col-12 col-md-8" :class="medic.block_d ?  'text-muted' : ''">
                                        <div>{{ medic.item.st_medicamento }}</div>
                                        <span class="text-muted">{{ medic.quantidade }}</span>
                                        <span class="text-muted" style="white-space: pre-wrap;" v-html="medic.complemento"></span>
                                        <div class="small text-muted" v-if="medic.st_ciclo_dias">{{ medic.st_ciclo_dias }}</div>
                                        <div class="small text-muted" v-if="medic.st_observacoes">{{ medic.st_observacoes }}</div>

                                        <div v-if="medic.diluidos && medic.diluidos.length" class="mt-2">
                                            <div v-for="(diluido, idx) in medic.diluidos" :key="idx" :class="diluido.block_d ?  'text-muted' : ''">
                                                <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                                                {{ diluido.item.search }}
                                                <span v-if="diluido.in_quantidade">
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    <span class="text-muted">{{ diluido.in_quantidade }}{{ diluido.apresentacao ? ' ' + diluido.apresentacao.search : 'x' }}</span>
                                                    <span v-if="diluido.qtd_calc">
                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                        <strong class="text-muted">{{ diluido.qtd_calc }}</strong>
                                                    </span>
                                                </span>

                                                <span class="text-muted" v-if="diluido.st_ciclo_dias">
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    {{ diluido.st_ciclo_dias }}
                                                </span>

                                                <span v-if="1==0 && diluido.st_ciclo_dias">
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    <span class="text-muted">{{ diluido.st_ciclo_dias }}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <div v-if="medic.uso && medic.uso.in_intervalo_horas > 24" class="small text-muted">
                                            {{ medic.dt_fim_trat ? 'Período:' : 'Início:' }} {{ $util.getFormatDate(medic.dt_inicio_trat) }} <span v-if="medic.dt_fim_trat"> / {{ $util.getFormatDate(medic.dt_fim_trat) }}</span>
                                        </div>
                                        <div v-if="medic.js_prescricao_horarios">
                                            <div class="row no-gutters">
                                                <div class="col col-12" :class="tem_duracao(item, horario.hora) ? '' : 'col-md-6'" v-for="(horario, ihx) in medic.js_prescricao_horarios.horarios" :key="'M' + imx + '.H' + ihx">
                                                    <az-input
                                                        sizing="sm"
                                                        class="mr-1"
                                                        :type="tem_duracao(item, horario.hora) ? 'datetime-local' : 'time'"
                                                        :step="60"
                                                        :edicao="!aprazamento_fechado"
                                                        required
                                                        :validate="validate"
                                                        v-model="horario.hora">

                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" id="button-addon2" 
                                                                    @click="medic.js_prescricao_horarios.horarios.splice(ihx, 1)"
                                                                    v-if="!aprazamento_fechado">
                                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>

                                                        <template v-slot:buttonposb>

                                                            <div class="input-group-append" v-if="horario.hora && !aprazamento_fechado">
                                                                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                                </button>
                                                                <div class="dropdown-menu">
                                                                    <a class="dropdown-item" href="#" @click.prevent="replicar_horarios(medic, horario, 2)">2/2h</a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="replicar_horarios(medic, horario, 3)">3/3h</a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="replicar_horarios(medic, horario, 4)">4/4h</a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="replicar_horarios(medic, horario, 6)">6/6h</a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="replicar_horarios(medic, horario, 8)">8/8h</a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="replicar_horarios(medic, horario, 12)">12/12h</a>
                                                                    <a class="dropdown-item" href="#" @click.prevent="replicar_horarios(medic, horario, 24)">24/24h</a>
                                                                </div>
                                                            </div>
                                                        </template>

                                                    </az-input>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex justify-content-between" v-if="!aprazamento_fechado">
                                            <div>
                                                <div class="btn-group" role="group" aria-label="Basic example" v-if="!medic.block_d">
                                                    <div class="dropdown">
                                                        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            {{ qtde }}
                                                        </button>
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <a class="dropdown-item" href="#" v-for="qtd in 6" @click.prevent="qtde = qtd" :key="qtd">
                                                                {{ qtd }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <button type="button" class="btn btn-primary btn-sm" @click="incluir_horario(medic)">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
        
                                                <button type="button" class="btn btn-outline-secondary btn-sm ml-1" @click="gerar_horarios(medic)" title="Gerar horários." v-if="tem_uso_magic(medic)">
                                                    <i class="fa-solid fa-wand-sparkles"></i>
                                                </button>

                                                <div class="small text-muted" v-if="ativas && ativas[medic.id_medicamento]">
                                                    Anterior: 
                                                    {{ $util.getFormatDate(ativas[medic.id_medicamento], 'DD/MM') }}
                                                    {{ ativas[medic.id_medicamento].slice(11,16) }}
                                                </div>
                                            </div>

                                            <div>
                                                <span class="badge badge-secondary" title="Horários" v-if="medic && medic.js_prescricao_horarios && medic.js_prescricao_horarios.horarios && medic.js_prescricao_horarios.horarios.length">
                                                    {{ medic.js_prescricao_horarios.horarios.length }}
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <hr>
                            </tr>
                        </table>

                        <br><br><br><br>

                        <pre v-if="false" class="alert alert-warning mt-3">{{ ativas }}</pre>
                        <pre v-if="false" class="alert alert-warning mt-3">{{ item }}</pre>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div>
                            <az-input
                                v-if="!aprazamento_fechado"
                                sizing="sm"
                                :type="tem_prescr_dias ? 'datetime-local' : 'time'"
                                :step="60"
                                :compact="true"
                                label="Hora Base"
                                v-model="hora_base">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <template v-if="ativas">
                                            <div class="btn-group dropup ml-1">
                                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <i class="fa-solid fa-wand-sparkles"></i>
                                                </button>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="#" @click.prevent="gerar_todos_horarios(true)">
                                                        Gerar pelo último horário
                                                    </a>
                                                    <a class="dropdown-item" href="#" @click.prevent="gerar_todos_horarios()">
                                                        Gerar pela hora base
                                                    </a>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="gerar_todos_horarios()">
                                                <i class="fa-solid fa-wand-sparkles"></i>
                                            </button>
                                        </template>

                                        <template v-if="hora_opcoes && hora_opcoes.length">
                                            <div class="btn-group dropup ml-1">
                                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <i class="fa fa-clock" aria-hidden="true"></i>
                                                </button>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="#" v-for="(hora, ihx) in hora_opcoes.slice(0, 10)" :key="'H' + ihx" @click.prevent="hora_base = hora">
                                                        {{ $util.getFormatDate(hora) }} {{ hora.slice(11,16) }}
                                                    </a>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">Fechar</button>
                            <az-submit v-if="!aprazamento_fechado" @click="salvar_aprazamento()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import * as moment from "moment";

export default {
    data() {
        return { 
            item: null, 
            qtde: 1, 
            validate: false, 
            hora_base: "", 
            apraza_data: false, 
            hora_opcoes: [], 
            ativas: null, 
        }
    },

    components: { 
        AzSubmit,
        AzInput
    },

    computed: { 
        aprazamento_fechado: function () { 
            if ( this.item && this.item.dt_valid_ini && this.item.solicitacao ) { 
                return true; 
            }

            return false; 
        },

        tem_prescr_dias: function () { 
            if ( this.item 
                && this.item.in_duracao > 1 
                && this.item.anamnese 
                && this.item.anamnese.atendimento_procedimento.atendimento.id_tipo_atendimento == 7 ) { 
                return this.item.in_duracao; 
            }

            return this.apraza_data ? 1 : false; 
        }
    },
    
    methods: { 
        gerar_todos_horarios (pelo_ultimo = false) { 

            this.item.items.forEach(item => { 
                this.gerar_horarios(item, pelo_ultimo);
            });

        },

        gerarDatasPorHoras(inicio, fim, listaHoras) {
            const dataInicio = moment(inicio, 'YYYY-MM-DD HH:mm');
            const dataFim = moment(fim, 'YYYY-MM-DD HH:mm');

            const resultado = [];

            let diaAtual = dataInicio.clone().startOf('day');
            const ultimoDia = dataFim.clone().startOf('day');

            while (diaAtual.isSameOrBefore(ultimoDia, 'day')) {
                listaHoras.forEach(hora => {
                    const dataHora = moment(
                        `${diaAtual.format('YYYY-MM-DD')} ${hora}`,
                        'YYYY-MM-DD HH:mm'
                    );

                    if (dataHora.isSameOrAfter(dataInicio) &&
                        dataHora.isSameOrBefore(dataFim)) {
                        resultado.push(dataHora.format('YYYY-MM-DD HH:mm'));
                    }
                });

                diaAtual.add(1, 'day');
            }

            return resultado;
        },

        gerarHorasPorIntervalo(inicio, fim, intervaloHoras, incluirInicio = true, incluirFim = false) {
            const dataInicio = moment(inicio, 'YYYY-MM-DD HH:mm');
            const dataFim = moment(fim, 'YYYY-MM-DD HH:mm');

            const resultado = [];

            let atual = dataInicio.clone();

            if (!incluirInicio) {
                atual.add(intervaloHoras, 'hours');
            }

            while (
                atual.isBefore(dataFim) ||
                (incluirFim && atual.isSame(dataFim))
            ) {
                let horaFormatada = atual.format('YYYY-MM-DD HH:mm');

                if ( horaFormatada >= this.item.dt_valid_ini && horaFormatada < this.item.dt_valid_fim ) {
                    resultado.push(horaFormatada);
                }

                atual.add(intervaloHoras, 'hours');
            }

            return resultado;
        },

        gerar_horarios (item, pelo_ultimo = false) { 
            if ( item && item.uso && item.uso.st_tipo_horarios == 'L' ) { 

                if ( item.uso.js_horarios && item.uso.js_horarios.lista && item.uso.js_horarios.lista.length ) { 

                    if ( item && !item.js_prescricao_horarios ) { 
                        item.js_prescricao_horarios = { horarios: [] }; 
                    } else { 
                        item.js_prescricao_horarios.horarios = []; 
                    }

                    if ( this.tem_prescr_dias ) { 

                        let dia_base = this.hora_base ? moment(this.hora_base, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD') : this.$util.hoje();

                        //

                        if ( this.item && this.item.dt_valid_ini && this.item.dt_valid_fim ) { 

                            let lista = item.uso.js_horarios.lista.map(h => h.hor).sort(); 
                            let inicio = (this.hora_base && this.hora_base > this.item.dt_valid_ini) ? this.hora_base : this.item.dt_valid_ini;
                            lista = this.gerarDatasPorHoras(inicio, this.item.dt_valid_fim, lista);

                            lista.forEach(hora => { 
                                this.incluir_horario(item, 1, hora);
                            });

                        } else { 

                            for (let idx_dia = 0; idx_dia < this.tem_prescr_dias; idx_dia++) {

                                let data_hora_dia = moment(dia_base, 'YYYY-MM-DD').add(idx_dia, 'days').format('YYYY-MM-DD');
                                let nova_hora = ""; 
                                let qtde = item.uso.js_horarios.lista.length;

                                for (let index = 0; index < qtde; index++) {

                                    let hora = item.uso.js_horarios.lista[index];

                                    console.log(nova_hora.slice(-5), hora.hor);

                                    if ( nova_hora && nova_hora.slice(-5) > hora.hor ) { 

                                        if ( ( index + 1 ) == qtde ) { 
                                            continue; 
                                        }

                                        data_hora_dia = moment(data_hora_dia, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
                                        
                                    }

                                    nova_hora = data_hora_dia + ' ' + hora.hor;
                                    this.incluir_horario(item, 1, nova_hora);

                                }

                            }

                        }

                    } else { 

                        item.uso.js_horarios.lista.forEach(hora => { 
                            this.incluir_horario(item, 1, hora.hor);
                        });

                    }

                }

            } else if ( item && item.uso && ( item.uso.st_tipo_horarios == 'I' ) && item.uso.in_intervalo_horas ) { 

                let qtde = Math.round(24 / item.uso.in_intervalo_horas);
                let hora_base = _.get(item, 'js_prescricao_horarios.horarios.0.hora', this.hora_base);

                if ( !hora_base ) { 
                    this.$toast.add({ 
                        severity: 'warn', 
                        summary: _.get(item, 'item.search', 'Aprazamento'), 
                        detail: 'Informe o primeiro horário para gerar o aprazamento.', 
                        life: 5000
                    })
                    return; 
                }
                
                if ( item && !item.js_prescricao_horarios ) { 
                    item.js_prescricao_horarios = { horarios: [] }; 
                } else { 
                    item.js_prescricao_horarios.horarios = []; 
                }

                if ( this.tem_prescr_dias ) { 

                    if ( this.item && this.item.dt_valid_ini && this.item.dt_valid_fim ) { 

                        let inicio = (this.hora_base && this.hora_base > this.item.dt_valid_ini) ? this.hora_base : this.item.dt_valid_ini;

                        if ( pelo_ultimo && _.get(this.ativas, item.id_medicamento) ) { 
                            inicio = this.ativas[item.id_medicamento]; 
                        }

                        let lista = this.gerarHorasPorIntervalo(inicio, this.item.dt_valid_fim, item.uso.in_intervalo_horas);

                        lista.forEach(hora => { 
                            this.incluir_horario(item, 1, hora);
                        });

                    } else { 

                        if ( item.uso.in_intervalo_horas > 24 ) { 

                            let diff_dias = 0; 

                            if ( item.dt_inicio_trat ) { 
                                let inicio = moment(item.dt_inicio_trat, 'YYYY-MM-DD');
                                let fim = moment(hora_base, 'YYYY-MM-DD HH:mm');

                                diff_dias = fim.diff(inicio, 'days');
                            }

                            for (let idx_dia = 0; idx_dia < this.tem_prescr_dias; idx_dia++) {

                                if ( item.dt_inicio_trat ) { 
                                    if ( ( diff_dias + idx_dia ) % Math.round( item.uso.in_intervalo_horas / 24 ) != 0 ) { 
                                        continue; 
                                    }
                                } else { 
                                    if ( idx_dia % Math.round( item.uso.in_intervalo_horas / 24 ) != 0 ) { 
                                        continue; 
                                    }
                                }

                                let nova_hora = moment(hora_base, 'YYYY-MM-DD HH:mm')
                                    .add(idx_dia, 'days')
                                    // .add(item.uso.in_intervalo_horas * index, 'hours')
                                    .format('YYYY-MM-DD HH:mm');

                                this.incluir_horario(item, 1, nova_hora);

                            }

                        } else { 

                            for (let idx_dia = 0; idx_dia < this.tem_prescr_dias; idx_dia++) {

                                for (let index = 0; index < qtde; index++) {
                                    let nova_hora = moment(hora_base, 'YYYY-MM-DD HH:mm')
                                        .add(idx_dia, 'days')
                                        .add(item.uso.in_intervalo_horas * index, 'hours')
                                        .format('YYYY-MM-DD HH:mm');

                                    this.incluir_horario(item, 1, nova_hora);
                                }

                            }

                        }

                    }

                } else { 

                    for (let index = 0; index < qtde; index++) {
                        let nova_hora = moment(hora_base, 'HH:mm').add(item.uso.in_intervalo_horas * index, 'hours').format('HH:mm');
                        this.incluir_horario(item, 1, nova_hora);
                    }

                }

            }

        },

        tem_uso_magics () { 

            if ( !this.item || !this.item.items || !this.item.items.length ) { 
                return false;
            }

            for (let index = 0; index < this.item.items.length; index++) {
                const element = this.item.items[index];
                if ( this.tem_uso_magic(element) ) { 
                    return true;
                }
            }

            return false; 

        },

        tem_uso_magic (item) { 
            if ( item && item.js_prescricao_horarios && item.js_prescricao_horarios.horarios && item.js_prescricao_horarios.horarios.length > 1 ) { 
                return false;
            }

            if ( item && item.uso && item.uso.st_tipo_horarios == 'L' ) { 
                if ( item.uso.js_horarios && item.uso.js_horarios.lista && item.uso.js_horarios.lista.length ) { 
                    return true;
                }
            }

            if ( item && item.uso && item.uso.st_tipo_horarios == 'I' ) { 
                if ( item.uso.in_intervalo_horas ) { 
                    return true;
                }
            }

            return false; 
        },

        gerarHoras(inicio, fim, incluirInicio = true, incluirFim = true) {
            const dataInicio = moment(inicio, 'YYYY-MM-DD HH:mm');
            const dataFim = moment(fim, 'YYYY-MM-DD HH:mm');

            const horas = [];

            let atual = dataInicio.clone();

            // Se a hora inicial estiver "quebrada", avança para a próxima hora inteira
            if (atual.minutes() !== 0 || atual.seconds() !== 0 || atual.milliseconds() !== 0) {
                atual.startOf('hour').add(1, 'hour');
            } else if (!incluirInicio) {
                // Se já for uma hora inteira, mas não deve incluir o início
                atual.add(1, 'hour');
            }

            while (
                atual.isBefore(dataFim) ||
                (incluirFim && atual.isSame(dataFim))
            ) {
                horas.push(atual.format('YYYY-MM-DD HH:mm'));
                atual.add(1, 'hour');
            }

            return horas;
        }, 

        aprazar (receita, ativas = null) { 
            this.hora_base = ""; 
            this.hora_opcoes = []; 
            this.item = _.cloneDeep(receita);
            this.ativas = null; 
            
            if ( this.item && this.item.dt_valid_ini && this.item.dt_valid_fim ) { 
                this.apraza_data = true; 
                this.hora_base = this.item.dt_valid_ini.slice(0, 16);
                this.hora_opcoes = this.gerarHoras(this.item.dt_valid_ini, this.item.dt_valid_fim, false, true);

                let itens_by_id = _.keyBy(this.item.items, 'id_medicamento');

                if ( ativas && ativas.length ) {

                    let ativas_filtradas = _.cloneDeep(ativas).filter(item => item.id_receita != this.item.id_receita
                        && item.dt_valid_fim == this.item.dt_valid_ini
                    )
                    .flatMap(item => item.items)
                    .filter(item => item.js_prescricao_horarios 
                        && item.js_prescricao_horarios.horarios 
                        && item.js_prescricao_horarios.horarios.length
                        && _.get(itens_by_id, item.id_medicamento)
                    );

                    ativas_filtradas = _.groupBy(ativas_filtradas, 'id_medicamento');
                    ativas_filtradas = _.map(ativas_filtradas, itens => {
                        let item = itens[0]; 
                        let horarios = itens.flatMap(i => i.js_prescricao_horarios.horarios.map(h => h.hora)).sort(); 
                        return { 
                            id_medicamento: item.id_medicamento, 
                            ultimo: _.last(horarios), 
                        }
                    }); 

                    if ( ativas_filtradas.length ) { 
                        this.ativas = _.fromPairs(ativas_filtradas.map(item => [item.id_medicamento, item.ultimo]));
                    }

                }

            } else if ( this.$store.state.contexto['prescricao-apraza-data'] ) { 
                this.apraza_data = true; 
            }

            this.$nextTick(() => { 
                $('#aprazamentoModal').modal('show');
            });
        },

        tem_duracao (receita, hora = '') { 
            if ( this.item && this.item.dt_valid_ini && this.item.dt_valid_fim ) { 
                return true;
            }

            if ( hora && hora.length <= 5 ) { 
                return false;
            }

            if ( hora && hora.length > 10 ) { 
                return true;
            }

            if ( receita.in_duracao > 1 && _.get(receita, 'anamnese.atendimento_procedimento.atendimento.id_tipo_atendimento') == 7 ) { 
                return true;
            }

            return false;
        },

        replicar_horarios (medic, horario, intervalo, data_base = null) { 

            let qtde = ( 24 / intervalo ) - 1;
            let base = horario.hora.slice(-5); 
            let data = data_base ? data_base : ( horario.hora.length > 5 ? horario.hora.slice(0, 10) : this.$util.hoje() );

            if ( horario.hora.length == 5 ) { 
                horario.hora = data + ' ' + horario.hora;
            }

            for (let index = 0; index < qtde; index++) {
                let nova_hora = moment(base, 'HH:mm').add(intervalo * (index + 1), 'hours').format('HH:mm');

                if ( nova_hora < base ) { 
                    nova_hora = moment(data, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD') + ' ' + nova_hora;
                } else { 
                    nova_hora = data + ' ' + nova_hora;
                }

                if ( !medic.js_prescricao_horarios.horarios.find(h => h.hora == nova_hora) ) { 
                    medic.js_prescricao_horarios.horarios.push({ 
                        hora: nova_hora,
                        status: "A", 
                        obs: "",
                        responsavel_atualizacao: [{
                            st_nome: this.$store.state.user.pessoa.st_nome, 
                            id_pessoa: this.$store.state.user.pessoa.id_pessoa,
                            dt_atualizacao: moment().format('YYYY-MM-DD HH:mm')
                        }]
                    });
                }
            }

            if ( this.item.in_duracao > 1 && this.item.anamnese && this.item.anamnese.atendimento_procedimento.atendimento.id_tipo_atendimento == 7 && !data_base && horario.hora.length > 5 ) { 

                for (let index = 0; index < ( this.item.in_duracao - 1 ); index++) {
                    
                    let limite = moment(this.item.dt_referencia, 'YYYY-MM-DD HH:mm').add(this.item.in_duracao, 'days').format('YYYY-MM-DD');
                    data_base = moment(data, 'YYYY-MM-DD').add(index + 1, 'days').format('YYYY-MM-DD');

                    if ( data_base < limite ) { 

                        let nova_hora = data_base + ' ' + horario.hora.slice(-5);

                        medic.js_prescricao_horarios.horarios.push({ 
                            hora: nova_hora,
                            status: "A", 
                            obs: "",
                            responsavel_atualizacao: [{
                                st_nome: this.$store.state.user.pessoa.st_nome, 
                                id_pessoa: this.$store.state.user.pessoa.id_pessoa,
                                dt_atualizacao: moment().format('YYYY-MM-DD HH:mm')
                            }]
                        });

                        this.replicar_horarios(medic, horario, intervalo, data_base);

                    }

                }

            }

        },

        incluir_horario (medic, qtde = null, hora = "") { 
            if ( !medic.js_prescricao_horarios ) { 
                medic.js_prescricao_horarios = { 
                    horarios: [],
                };
            }

            if ( !medic.dt_inicio_trat && ( _.get(medic, 'uso.in_intervalo_horas') > 24 ) ) { 
                if ( hora && hora.length > 10 ) { 
                    medic.dt_inicio_trat = hora.slice(0, 10);
                } else { 
                    medic.dt_inicio_trat = this.$util.hoje(); 
                }
            }

            if ( qtde === null ) { 
                qtde = this.qtde;
            }

            for (let index = 0; index < qtde; index++) {
                
                medic.js_prescricao_horarios.horarios.push({ 
                    hora: hora,
                    status: "A", 
                    obs: "",
                    responsavel_atualizacao: [{
                        st_nome: this.$store.state.user.pessoa.st_nome, 
                        id_pessoa: this.$store.state.user.pessoa.id_pessoa,
                        dt_atualizacao: moment().format('YYYY-MM-DD HH:mm')
                    }]
                });

            }
        },

        salvar_aprazamento () { 
            if ( this.item.dt_valid_ini && this.item.dt_valid_fim ) { 
                let invalido = this.item.items.find(medic => { 
                    if ( !medic.js_prescricao_horarios || !medic.js_prescricao_horarios.horarios || !medic.js_prescricao_horarios.horarios.length ) { 
                        return false; 
                    }

                    let horario_invalido = medic.js_prescricao_horarios.horarios.find(h => 
                        ( moment(h.hora, "YYYY-MM-DD HH:mm").format('YYYY-MM-DD HH:mm') < this.item.dt_valid_ini ) 
                        || ( moment(h.hora, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm') >= this.item.dt_valid_fim ) 
                    );

                    if ( horario_invalido ) { 
                        console.log('Faixa', this.item.dt_valid_ini, this.item.dt_valid_fim);
                        console.log('Horario', this.$util.getFormatDate(horario_invalido.hora, 'YYYY-MM-DD HH:mm'));
                        console.log('Horario inválido', horario_invalido);
                        return true; 
                    }
                });

                if ( invalido ) { 
                    this.$toast.add({ 
                        severity: 'warn', 
                        summary: 'Aprazamento', 
                        detail: 'Existem horários fora do período de aprazamento. \n'
                            + invalido.item.search, 
                        life: 5000
                    })
                    return; 
                }
            }

            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'aprazar',
                dados: this.item,
                modal: 'aprazamentoModal',
                callback: () => { 
                    this.$emit('refresh');

                    if ( this.item && this.item.dt_valid_ini && !this.item.solicitacao ) { 
                        this.$emit('solicitar', this.item);
                    }
                },
            });
        },

    }
}
</script>
